export default __webpack_public_path__ + "static/media/black-ambition-logo.53a386b1.jpg";